import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import Collection from './Collection';

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/List.html
 */
var List = /*#__PURE__*/function (_Collection) {
  _inherits(List, _Collection);
  function List() {
    _classCallCheck(this, List);
    return _possibleConstructorReturn(this, _getPrototypeOf(List).apply(this, arguments));
  }
  _createClass(List, [{
    key: "get",
    /**
       * Returns the element at the specified position in this list.
       * @param {number} index
       * @return {Object}
       */
    value: function get() {}
    /**
       * Replaces the element at the specified position in this list with the
       * specified element (optional operation).
       * @param {number} index
       * @param {Object} e
       * @return {Object}
       */
  }, {
    key: "set",
    value: function set() {}
    /**
       * Returns true if this collection contains no elements.
       * @return {boolean}
       */
  }, {
    key: "isEmpty",
    value: function isEmpty() {}
  }]);
  return List;
}(Collection);
export { List as default };